import { api } from './api';
import type { Allergen } from '../types';

export const allergenService = {
  async getAll(): Promise<Allergen[]> {
    const response = await api.get('/allergens');
    return response.data;
  },

  async getById(id: string): Promise<Allergen> {
    const response = await api.get(`/allergens/${id}`);
    return response.data;
  },

  async getStats() {
    const response = await api.get('/allergens/stats');
    return response.data;
  },
};
